export default "__VITE_ASSET__BoPIv8Z2__"